
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'InlineAlert',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    }
  },
  methods: {
    t(key: string): string {
      return this.$t(key) as string;
    }
  }
});
